export default __webpack_public_path__ + "static/3-12f5ebf04a46d83f6d5ff6e628610568.gif";